import { createReducer } from 'typesafe-actions';

import { IP2PState, TP2PAction, P2PActionTypes } from '@/store/types/p2p.types';

const initialState: IP2PState = {
  transfers: [],
  beneficiariesP2P: undefined,
  isLoading: false,
  wallets: undefined,
  currentFilters: {},
};

export const p2pReducer = createReducer<IP2PState, TP2PAction>(initialState)
  .handleType(P2PActionTypes.P2P_TRANSFER, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(P2PActionTypes.P2P_TRANSFER_SUCCESS, (state, action) => ({
    ...state,
    transfer: action.transfer,
    beneficiariesP2P: undefined,
    currentFilters: {},
    wallets: undefined,
    isLoading: false,
    error: undefined,
  }))

  .handleType(P2PActionTypes.P2P_TRANSFER_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(P2PActionTypes.P2P_SEARCH_WALLETS, (state) => ({
    ...state,
    wallets: { isLoading: true, error: undefined },
  }))

  .handleType(P2PActionTypes.P2P_SEARCH_WALLETS_SUCCESS, (state, action) => ({
    ...state,
    wallets: { state: action.wallets, isLoading: false, error: undefined },
  }))

  .handleType(P2PActionTypes.P2P_SEARCH_WALLETS_FAIL, (state, action) => ({
    ...state,
    wallets: { state: undefined, isLoading: false, error: action.error },
  }))

  .handleType(P2PActionTypes.P2P_UNSET_WALLETS, (state) => ({
    ...state,
    wallets: { state: undefined, isLoading: false, error: undefined },
  }));
